import { v4 as uuidv4 } from "uuid";

const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Returns a fresh UUID v4 suitable for X-Request-Id headers.
 *
 * @returns {string}
 */
export function generateRequestId() {
  return uuidv4();
}

/**
 * Validates a value against the spec §6.3 UUID v4 regex.
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidRequestId(value) {
  return typeof value === "string" && UUID_V4_REGEX.test(value);
}
